var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 68,
    r: 10,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#2F2E79",
    strokeWidth: 3,
    transform: "translate(-414 -56)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioEmpty);
export default __webpack_public_path__ + "static/media/radio-empty.0568a876a262cdbabac50b1226de3552.svg";
export { ForwardRef as ReactComponent };